import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import GameProp from '../propTypes/gameProp';
import Request from '../../../services/request';
import Notifications from '../../../services/notifications';
import translate from '../../../commonComponents/translate';
import CourseContentDetails from '../../academy/details/CourseContentDetails';
import AppProductProp from '../../profile/propTypes/appProductProp';
import CountryProp from '../../../commonComponents/forms/Address/CountryProp';
import StripeCardProp from '../../profile/propTypes/StripeCardProp';

function Course(props) {
  const {
    t,
    challenge,
    cards,
    appProducts,
    countries,
    onChange,
    pspdfkitLicenseKey,
  } = props;

  const [isLoading, setIsLoading] = useState(true);
  const [course, setCourse] = useState(null);
  useEffect(
    () => {
      setIsLoading(true);
      if (!challenge.courses || challenge.courses.length < 1) {
        Notifications.showNotificationError(
          t('error'),
          t('error_fetchChallengeCourse'),
        );
      } else {
        const [c] = challenge.courses;
        const courseId = typeof c === 'string' ? c : c._id;
        new Request()
          .get(`/academy/${courseId}/data?gameId=${challenge._id}`)
          .done(({ data }) => {
            setCourse(data);
            setIsLoading(false);
          })
          .fail(err => {
            Notifications.showErrorFromRequest(
              err,
              'error_fetchChallengeCourse',
            );
            setIsLoading(false);
          });
      }
    },
    [challenge],
  );

  return (
    <div className="m-portlet__body">
      {isLoading ? (
        <div className="loading-indicator" />
      ) : (
        <CourseContentDetails
          course={course}
          gameId={challenge._id}
          cards={cards}
          appProducts={appProducts}
          countries={countries}
          onCourseChange={onChange}
          pspdfkitLicenseKey={pspdfkitLicenseKey}
        />
      )}
    </div>
  );
}

Course.propTypes = {
  t: PropTypes.func.isRequired,
  challenge: PropTypes.shape(GameProp.propType).isRequired,
  countries: PropTypes.arrayOf(PropTypes.shape(CountryProp.propType))
    .isRequired,
  cards: PropTypes.arrayOf(PropTypes.shape(StripeCardProp.propType)).isRequired,
  onChange: PropTypes.func,
  appProducts: PropTypes.arrayOf(PropTypes.shape(AppProductProp.propType)).isRequired,
  pspdfkitLicenseKey: PropTypes.string,
};

Course.defaultProps = {
  onChange: null,
  pspdfkitLicenseKey: null,
};

export default translate(Course);
